import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderDots,
  SliderItem,
  SliderBtn,
  SliderProgress,
} from '@studiometa/ui';
import SliderDrag from './SliderDrag.js';

/**
 * Slider component
 * @param  {Class} SliderCore
 * @returns {void}
 */
export default class Slider extends withBreakpointObserver(SliderCore) {
  static config = {
    components: {
      SliderDots,
      SliderDrag,
      SliderItem,
      SliderBtn,
      SliderProgress,
    },
    options: {
      ...SliderCore.config.options,
      fitBounds: {
        type: Boolean,
        default: true,
      },
    },
  };
}
